export default class ProjectType
{

	static TYPE_TYPO3 = 'typo3';
	static TYPE_FLOW = 'flow';
	static TYPE_NEOS = 'neos';

	constructor(type) {
		this.type = type;
	}

	static getOptions() {
		return [
			{value: ProjectType.TYPE_TYPO3, label: 'TYPO3'},
			{value: ProjectType.TYPE_FLOW, label: 'Flow'},
			{value: ProjectType.TYPE_NEOS, label: 'Neos'}
		];
	}
}



// WEBPACK FOOTER //
// ./React/src/enums/ProjectType.js